import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { buildSharedViewDetailRows } from '@/utils/filter/sharedViewDetailRows';
import type { SharedViewFailureDetails } from '@/utils/filter/sharedViewDiagnostics';
import { TestIds } from '@/components/filter/SharedViewDialog/testIds';
import styles from './SharedViewErrorDetails.module.css';

export interface SharedViewErrorDetailsProps {
  details: SharedViewFailureDetails;
}

const SharedViewErrorDetails: FC<SharedViewErrorDetailsProps> = ({ details }) => {
  const { t } = useTranslation();
  const rows = buildSharedViewDetailRows(details, t);

  return (
    <dl className={styles.details} data-testid={TestIds.container}>
      {rows.map(detailRow => (
        <div key={detailRow.id} className={styles.row}>
          <dt className={styles.term}>{detailRow.label}</dt>
          <dd className={styles.description} data-testid={TestIds.row(detailRow.id)}>
            {detailRow.isList ? (
              <ul className={styles.reasonList} data-testid={TestIds.reasonList}>
                {detailRow.values.map(valueText => (
                  <li key={valueText}>{valueText}</li>
                ))}
              </ul>
            ) : (
              detailRow.values.join('; ')
            )}
          </dd>
        </div>
      ))}
    </dl>
  );
};

export default SharedViewErrorDetails;
